export type GeetestChallenge = {
	captchaId: string;
	challenge: string;
	serviceStatus: boolean;
};

export type GeetestConfig = {
	captchaId: string;
	hideBar?: string;
	language?: Lowercase<string>;
	offline?: boolean;
	outside?: false;
	product?: 'bind' | 'custom' | 'float' | 'popup';
	protocol?: string;
};

export type GeetestSuccessResponse = {
	captcha_id: string;
	captcha_output: string;
	gen_time: string;
	lot_number: string;
	pass_token: string;
};

export const enum GeetestStatus {
	Close = 'close',
	Error = 'error',
	Fail = 'fail',
	Ready = 'ready',
	Success = 'success'
}

export type GeetestChallengeMetadata = {
	details: {
		countryCode: string;
		mobileNumber: string;
	};
	type: 'phone-number';
};
